import { defineStore } from 'pinia';
import { State } from '@/store/services/types';
import { state } from './state';
import { actions } from './actions';

export const useServicesStore = defineStore('services', {
  state: (): State => state,
  actions,
});
